
import { getReservationClient } from '@/api/reservationClient';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'ApplicationInfo',
  components: {
  },
})

export default class extends Vue {
  @Prop({ default: '' }) private clientUidProp!: any;

  private clientUid = this.$route.params.uid;

  mounted() {
    this.getReservationClient();
  }

  private cancelModifyDialog = false;

  private loading = true;

  private reservationDetail: any = {
    uid: '',
    reservationCode: '',
    facilityName: '',
    name: '',
    phone: '',
    gender: 0,
    postCode: '',
    address: '',
    addressDetail: '',
    email: '',
    fewDay: 1,
    price: 0,
    settingUnitStatus: 1,
    hourUnitStatus: false,
    hours: [],
    startTime: '',
    endTime: '',
    item: {
      uid: '',
      name: '',
      category: {
        uid: '',
        name: '',
      },
      institution: {
        uid: '',
      },
    },
    discountPolicy: {
      uid: '',
      title: '',
    },
    people: 1,
    totalPeople: 0,
    groupReservationStatus: true,
    groupReservation: [],
    additionals: [],
    paymentType: 'Card',
    status: 0,
    approvalStatus: false,
    paymentStatus: true,
    participationDate: '', // 벼룩시장
    itemName: '', // 벼룩시장
    boardingPlace: 0, // 낭만버스 2코스
  };

  private basicPeople = 0;

  private getTotalAdditionalPrice() {
    let additionalPrice = 0;
    this.reservationDetail.additionals.forEach((additional: any) => {
      additionalPrice += additional.price * additional.useAmount;
    });
    return additionalPrice;
  }

  private getReservationClient() {
    this.loading = true;

    const clientUid = this.clientUid || this.clientUidProp;

    getReservationClient(clientUid).then((res) => {
      this.reservationDetail = res.data;
      this.loading = false;

      /* eslint-disable */
      res.data.fieldGroups.forEach((fieldGroup: any) => {
        fieldGroup.fields.forEach((clientInfo: any) => {
          if (clientInfo.fieldType === 'DATETIME_RANGE') {
            if (clientInfo.multipleStatus) {
              clientInfo.fieldValues.forEach((fieldValue: any, idx: number) => {
                fieldValue = fieldValue.replaceAll('[', '');
                fieldValue = fieldValue.replaceAll(']', '');
                clientInfo.fieldValues[idx] = fieldValue.split(',');
              });
            } else {
              if (clientInfo.fieldValue && clientInfo.fieldValue.indexOf('[') > -1 && clientInfo.fieldValue.indexOf(']') > -1) {
                clientInfo.fieldValue = clientInfo.fieldValue.replaceAll('[', '');
                clientInfo.fieldValue = clientInfo.fieldValue.replaceAll(']', '');
                clientInfo.fieldValue = clientInfo.fieldValue.split(',');
              }
            }
          }
        });
      });
      /* eslint-enable */
    });
  }

  private goList() {
    this.$router.push({ name: 'ReserveClient', query: { ...this.$route.query } });
  }

  private handlePrint() {
    const captureElement = document.getElementById('capture');

    if (captureElement) {
      captureElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    window.print();
  }

  private handleModify() {
    this.$router.push({ name: 'ReserveStatusForm', params: { uid: this.reservationDetail.uid }, query: { ...this.$route.query } });
  }

  private handleCancelModify() {
    this.cancelModifyDialog = !this.cancelModifyDialog;
  }

  /* eslint-disable */
  private handlePrintDocument(type: string) {
    const route = this.$router.resolve({
      name: 'ReservationClientPrintDocument',
      query: {
        clientUid: this.clientUid,
        type: type,
      },
    });
    window.open(route.href, '');
  }
  /* eslint-enable */

  private handleCancelGroupReservation() {
    this.handleCancelModify();
    this.getReservationClient();
  }
}
